<template>
    <div class="new-popup-box portraits-box fadeIn">
        <div class="hanlder-box">
            <svg class="icon-svg popup-close" @click="emit('close')">
                <use xlink:href="#icon-guanbi" />
            </svg>
        </div>
        <div class="box-content">
            <PortraitsContent :book="book"></PortraitsContent>
        </div>
    </div>
</template>
<script setup>
import { onMounted } from 'vue'
import PortraitsContent from "@/component/personal/portraits-info/portraits-content.vue";

const props = defineProps({
    book: Object,
})

const emit = defineEmits(['close'])


onMounted(() => {

})


</script>

<style lang="scss" scoped>
.portraits-box {
    .box-content {
        width: 1400px;
        max-width: 100%;
        overflow-y: auto;
        background-color: #136bb485;
        padding: 10px 50px;
    }
}


#content {
    &.phone-mode {
        .portraits-box {
            .box-content {
                max-height: 100%;
                max-width: 100%;
                padding: 0 10px;
            }
        }
    }
}
</style>